import Vue from "vue";
import App from "./App.vue";
import router from "@/router";
import store from "./store";
// import wx from "weixin-jsapi";
// import "babel-polyfill";  //兼容
import promise from "es6-promise";
// ===== element-ui 按需引入（替代全量 Vue.use(ElementUI)，配合 babel.config.js 的 babel-plugin-import 配置）=====
// 组件在 main.js 集中按需 import 并全局注册（共 41 个，见下方注册列表），
// 新增组件时在此处 import 即可，无需改动各页面；服务与指令也在此一并注册。
import {
  Aside, Autocomplete, Avatar, Backtop, Badge, Button, Calendar, Card, Cascader,
  Checkbox, CheckboxButton, CheckboxGroup, Collapse, CollapseItem, Container,
  DatePicker, Dialog, Drawer, Dropdown, DropdownItem, DropdownMenu, Form, FormItem,
  Header, Input, Main, Menu, MenuItem, Option, Pagination, Popover, Progress, Radio,
  RadioGroup, Select, Submenu, TabPane, Table, TableColumn, Tabs, Upload,
  Message, MessageBox, Loading, Notification, InfiniteScroll
} from "element-ui";
import "./components";
// import "normalize.css/normalize.css";
import "nprogress/nprogress.css";
import "./assets/styles/styles.scss";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
//引入echarts
// import echarts from 'echarts'
// Vue.prototype.$echarts = echarts
// 引入v-charts
// import VeLine from 'v-charts/lib/line.common'
// Vue.component(VeLine.name, VeLine);

require("es6-promise/auto");
// require('./utils/vconsole.js')
// promise.polyfill();

// import * as Sentry from "@sentry/browser";
// import { Vue as VueIntegration } from "@sentry/integrations";
// if (process.env.NODE_ENV == "development") {
//   // // 需要忽略的错误上报关键字
//   // let ignoreList = ['getAppToken']
//   // Sentry.init({
//   //   dsn: 'http://67e37c0676e34076a16349aca1fa95b0@sentry.gaokaozhitongche.com/2',
//   //   environment: 'vue-dev',
//   //   integrations: [new VueIntegration({ Vue, attachProps: true,logErrors: true })],
//   //   beforeSend(event){
//   //     console.log('event',event)
//   //     let shouldSend = true
//   //     ignoreList.forEach(item =>{
//   //       console.log(item)
//   //       if(event.exception.values[0].value.indexOf(item)>-1){
//   //         shouldSend = false
//   //       }
//   //     })
//   //     if(shouldSend){
//   //       return event
//   //     }
//   //     // return event
//   //   }
//   // });
// } else if (process.env.NODE_ENV == "test") {
//   Sentry.init({
//     dsn:
//       "https://67e37c0676e34076a16349aca1fa95b0@sentry.gaokaozhitongche.com/2",
//     environment: "vue-test",
//     release: process.env.VUE_APP_RELEASE_VERSION,
//     integrations: [
//       new VueIntegration({
//         Vue,
//         attachProps: true,
//         logErrors: true
//       })
//     ]
//   });
// } else if (process.env.NODE_ENV == "production") {
//   // 需要忽略的错误上报关键字
//   let ignoreList = ["getAppToken", "styleNight", "afterShare"];
//   Sentry.init({
//     dsn:
//       "https://67e37c0676e34076a16349aca1fa95b0@sentry.gaokaozhitongche.com/2",
//     environment: "vue-prod",
//     release: process.env.VUE_APP_RELEASE_VERSION,
//     integrations: [
//       new VueIntegration({
//         Vue,
//         attachProps: true,
//         logErrors: true
//       })
//     ],
//     beforeSend(event) {
//       // console.log('event',event)
//       let shouldSend = true;
//       ignoreList.forEach(item => {
//         if (event.exception.values[0].value.indexOf(item) > -1) {
//           shouldSend = false;
//         }
//       });
//       if (shouldSend) {
//         return event;
//       }
//     }
//   });
// }
// 在非正式，或者链接带上参数“debug=1”时，加入vconsole
if (process.env.NODE_ENV != "production" || window.location.search.indexOf('debug=1') > -1) {
  require("./utils/vconsole.js");
  window.onerror = function(
    errorMessage,
    scriptURI,
    lineNumber,
    columnNumber,
    error
  ) {
    console.log("错误", errorMessage);
  };
}

// ===== element-ui 按需引入：组件全局注册（服务/指令见下）=====
[Aside, Autocomplete, Avatar, Backtop, Badge, Button, Calendar, Card, Cascader,
  Checkbox, CheckboxButton, CheckboxGroup, Collapse, CollapseItem, Container,
  DatePicker, Dialog, Drawer, Dropdown, DropdownItem, DropdownMenu, Form, FormItem,
  Header, Input, Main, Menu, MenuItem, Option, Pagination, Popover, Progress, Radio,
  RadioGroup, Select, Submenu, TabPane, Table, TableColumn, Tabs, Upload
].forEach(C => {
  if (!Vue.component(C.name)) Vue.component(C.name, C);
});

// 注册指令：v-loading 遮罩 与 v-infinite-scroll 滚动加载（全量 Vue.use 时会自动注册，按需引入需手动补）
Vue.directive("loading", Loading.directive);
Vue.use(InfiniteScroll);

// 注册服务到 Vue 原型，供 this.$message / $confirm / $alert / $loading / $notify 使用
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$notify = Notification;
Vue.config.productionTip = false;
Vue.filter("numberFilter", v => {
  if (v > 9999) {
    return (v / 10000).toFixed(1) + "w ";
  } else if (v > 999) {
    return (v / 1000).toFixed(1) + "k ";
  } else {
    return v;
  }
});

import iosTools from "@/utils/tools/iosTools.js";
import andTools from "@/utils/tools/androidTools.js";
const u = navigator.userAgent;
if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
  console.log("iOS", u);
  Vue.use(iosTools);
} else {
  console.log("Android", u);
  Vue.use(andTools);
}

// import wx from "@/utils/tools/wxTools.js";
// Vue.use(wx);


import Storage from '@/utils/Storage'
Vue.prototype.$storage = Storage

import { Lazyload } from 'vant';
Vue.use(Lazyload)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
